
import CourseAssistedLivingCoachingPriceList from '@/views/App/Course/AssistedLivingCoaching/PriceList.vue';

const routesCourseAssistedLivingCoaching = [
    {
        path: 'list',
        name: 'courseAssistedLivingCoachingPriceList',
        component: CourseAssistedLivingCoachingPriceList
    },
];

export default routesCourseAssistedLivingCoaching;